<template>
  <div class="content">
    <div class="container-fluid">
      <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
        <vs-tabs>
          <vs-tab label="Conductores">
            <div class="con-tab-ejemplo">
              <div class="row">
                <div class="col-12">
                  <template class="header">
                    <div class="row" style="justify-content: space-between;">
                      <div>
                        <h4 style="margin-left: 15px!important;" class="card-title">Lista de Conductores</h4>
                      </div>
                      <div style="padding-right: 15px;">
                        <button style="border: none; background-color: #0d6efd;"
                          class="btn btn-info btn-fill float-right" @click.prevent="openCreateDriverPopup()">
                          Crear Conductor
                        </button>
                      </div>
                    </div>
                  </template>
                  <l-table @functionComponentDelete="confirmDeleteDriver" @functionComponentEdit="editDriver"
                    style="margin-left: -15px;" class="table-hover table-striped" :columns="tableDriver.columns"
                    :data="tableDriver.data">
                  </l-table>
                </div>
              </div>
            </div>
          </vs-tab>
          <!--<vs-tab label="Operadores">
            <div class="con-tab-ejemplo">
              <div class="row">
                <div class="col-12">
                    <template class="header">
                      <div class="row" style="justify-content: space-between;">
                        <div>
                          <h4 style="margin-left: 15px!important;" class="card-title">Lista de Operadores</h4>
                        </div>
                        <div style="padding-right: 15px;">
                          <button style="border: none; background-color: #0d6efd;"
                                  class="btn btn-info btn-fill float-right" @click.prevent="openCreateOperatorPopup()">
                            Crear Operador
                          </button>
                        </div>
                      </div>
                    </template>
                    <l-table @functionComponentDelete="confirmDeleteOperator" @functionComponentEdit="editOperator"
                            style="margin-left: -15px;" class="table-hover table-striped"
                            :columns="tableOperator.columns"
                            :data="tableOperator.data">
                    </l-table>
                </div>
              </div>
            </div>
          </vs-tab>-->
          <vs-tab label="Tarifas">
            <div class="con-tab-ejemplo">
              <div class="row">
                <div class="col-12">
                  <template class="header">
                    <div class="row" style="justify-content: space-between;">
                      <div>
                        <h4 style="margin-left: 15px!important;" class="card-title">Lista de Tarifas</h4>
                      </div>
                      <div style="padding-right: 15px;">
                        <button style="border: none; background-color: #0d6efd;"
                          class="btn btn-info btn-fill float-right" @click.prevent="openCreateFeePopup()">
                          Crear Tarifa
                        </button>
                      </div>
                    </div>
                  </template>
                  <l-table-fee @functionComponentDelete="confirmDeleteFee" @functionComponentEdit="editFee"
                    style="margin-left: -15px;" class="table-hover table-striped" :columns="tableFee.columns"
                    :data="tableFee.data">
                  </l-table-fee>
                </div>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Vehículos">
            <div class="con-tab-ejemplo">
              <div class="row">
                <div class="col-12">
                  <template class="header">
                    <div class="row" style="justify-content: space-between;">
                      <div>
                        <h4 style="margin-left: 15px!important;" class="card-title">Lista de Vehículos</h4>
                      </div>
                      <div style="padding-right: 15px;">
                        <button style="border: none; background-color: #0d6efd;"
                          class="btn btn-info btn-fill float-right" @click.prevent="openCreateVehiclePopup()">
                          Crear Vehículo
                        </button>
                      </div>
                    </div>
                  </template>
                  <l-table @functionComponentDelete="confirmDeleteVehicle" @functionComponentEdit="editVehicle"
                    style="margin-left: -15px;" class="table-hover table-striped" :columns="tableVehicle.columns"
                    :data="tableVehicle.data">
                  </l-table>
                </div>
              </div>
            </div>
          </vs-tab>
          <!--<vs-tab label="Centros de costo">
            <div class="con-tab-ejemplo">
              <div class="row">
                <div class="col-12">
                    <template class="header">
                      <div class="row" style="justify-content: space-between;">
                        <div>
                          <h4 style="margin-left: 15px!important;" class="card-title">Lista de Centros de Costo</h4>
                        </div>
                        <div style="padding-right: 15px;">
                          <button style="border: none; background-color: #0d6efd;"
                                  class="btn btn-info btn-fill float-right" @click.prevent="openCreateCostCenterPopup()">
                            Crear Centro de Costo
                          </button>
                        </div>
                      </div>
                    </template>
                    <l-table @functionComponentDelete="confirmDeleteCostCenter" @functionComponentEdit="editCostCenter"
                            style="margin-left: -15px;" class="table-hover table-striped"
                            :columns="tableCostCenter.columns"
                            :data="tableCostCenter.data">
                    </l-table>
                </div>
              </div>
            </div>
          </vs-tab>-->
          <vs-tab label="Dependencias">
            <div class="con-tab-ejemplo">
              <div class="row">
                <div class="col-12">
                  <template class="header">
                    <div class="row" style="justify-content: space-between;">
                      <div>
                        <h4 style="margin-left: 15px!important;" class="card-title">Lista de Dependencias</h4>
                      </div>
                      <div style="padding-right: 15px;">
                        <button style="border: none; background-color: #0d6efd;"
                          class="btn btn-info btn-fill float-right" @click.prevent="openCreateDependencePopup()">
                          Crear Dependencia
                        </button>
                      </div>
                    </div>
                  </template>
                  <l-table @functionComponentDelete="confirmDeleteDependence" @functionComponentEdit="editDependence"
                    style="margin-left: -15px;" class="table-hover table-striped" :columns="tableDependence.columns"
                    :data="tableDependence.data">
                  </l-table>
                </div>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </card>
      <vs-popup classContent="popup-example" title="Conductor" :active.sync="popupCreatedDriver">
        <div class="row">
          <div class="col-xl-4 col-md-4">
            <vs-input label="Nombre" class="inputx" placeholder="Nombre" v-model="formDriver.name" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Apellido" class="inputx" placeholder="Apellido" v-model="formDriver.lastName" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Teléfono" class="inputx" placeholder="Teléfono" v-model="formDriver.phone" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Numero de Documento" class="inputx" placeholder="Numero"
              v-model="formDriver.numberDocument" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Dirección" class="inputx" placeholder="Dirección" v-model="formDriver.address" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Correo" class="inputx" placeholder="Correo" v-model="formDriver.email" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Edad" class="inputx" placeholder="Edad" v-model="formDriver.years" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Observaciones" class="inputx" placeholder="Observaciones"
              v-model="formDriver.observations" />
          </div>
          <div style="align-self: flex-end; flex-basis: fit-content;" class="col-xl-4 col-md-4">
            <vs-checkbox style="font-size: medium;" v-model="formDriver.status">Estado</vs-checkbox>
          </div>
          <div style="align-self: flex-end; padding: 15px;" class="col-xl-4 col-md-4">
            <button style="border: none; background-color: #0d6efd; width: 100%;"
              class="btn btn-info btn-fill float-right" @click.prevent="createdEditDriver()">
              Insertar</button>
          </div>
        </div>
      </vs-popup>
      <vs-popup classContent="popup-example" title="Operador" :active.sync="popupCreatedOperator">
        <div class="row">
          <div class="col-xl-4 col-md-4">
            <vs-input label="Nombre" class="inputx" placeholder="Nombre" v-model="formOperator.name" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Apellido" class="inputx" placeholder="Apellido" v-model="formOperator.lastName" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Teléfono" class="inputx" placeholder="Teléfono" v-model="formOperator.phone" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Numero de Documento" class="inputx" placeholder="Numero"
              v-model="formOperator.numberDocument" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Dirección" class="inputx" placeholder="Dirección" v-model="formOperator.address" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Correo" class="inputx" placeholder="Correo" v-model="formOperator.email" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Edad" class="inputx" placeholder="Edad" v-model="formOperator.years" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Observaciones" class="inputx" placeholder="Observaciones"
              v-model="formOperator.observations" />
          </div>
          <div style="align-self: flex-end; flex-basis: fit-content;" class="col-xl-4 col-md-4">
            <vs-checkbox style="font-size: medium;" v-model="formOperator.status">Estado</vs-checkbox>
          </div>
          <div style="align-self: flex-end; padding: 15px;" class="col-xl-4 col-md-4">
            <button style="border: none; background-color: #0d6efd; width: 100%;"
              class="btn btn-info btn-fill float-right" @click.prevent="createdEditOperator()">
              Insertar</button>
          </div>
        </div>
      </vs-popup>
      <vs-popup classContent="popup-example" title="Tarifa" :active.sync="popupCreatedFee">
        <div class="row">
          <div class="col-xl-4 col-md-4">
            <vs-input label="Nombre" class="inputx" placeholder="Nombre" v-model="formFee.name" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Origen" class="inputx" placeholder="Origen" v-model="formFee.origin" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Destino" class="inputx" placeholder="Destino" v-model="formFee.destination" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Valor" class="inputx" placeholder="Valor" v-model="formFee.value" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Observaciones" class="inputx" placeholder="Observaciones" v-model="formFee.observations" />
          </div>
          <div style="align-self: flex-end; flex-basis: fit-content;" class="col-xl-4 col-md-4">
            <vs-checkbox style="font-size: medium;" v-model="formFee.status">Estado</vs-checkbox>
          </div>
          <div style="align-self: flex-end; padding: 15px;" class="col-xl-4 col-md-4">
            <button style="border: none; background-color: #0d6efd; width: 100%;"
              class="btn btn-info btn-fill float-right" @click.prevent="createdEditFee()">
              Insertar</button>
          </div>
        </div>
      </vs-popup>
      <vs-popup classContent="popup-example" title="Vehículo" :active.sync="popupCreatedVehicle">
        <div class="row">
          <div class="col-xl-4 col-md-4">
            <vs-input label="Cuenta" class="inputx" placeholder="Cuenta" v-model="formVehicle.cuenta" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Placa" class="inputx" placeholder="Placa" v-model="formVehicle.placa" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Marca" class="inputx" placeholder="Marca" v-model="formVehicle.marca" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Modelo" class="inputx" placeholder="Modelo" v-model="formVehicle.modelo" />
          </div>
          <div class="col-xl-4 col-md-4">
            <vs-input label="Color" class="inputx" placeholder="Color" v-model="formVehicle.color" />
          </div>
          <div style="align-self: flex-end; flex-basis: fit-content;" class="col-xl-4 col-md-4">
            <vs-checkbox style="font-size: medium;" v-model="formVehicle.status">Estado</vs-checkbox>
          </div>
          <div style="align-self: flex-end; padding: 15px;" class="col-xl-4 col-md-4">
            <button style="border: none; background-color: #0d6efd; width: 100%;"
              class="btn btn-info btn-fill float-right" @click.prevent="createdEditVehicle()">
              Insertar</button>
          </div>
        </div>
      </vs-popup>
      <vs-popup classContent="popup-example" title="Centro de Costo" :active.sync="popupCreatedCostCenter">
        <div class="row">
          <div class="col-xl-6 col-md-6">
            <vs-input label="Nombre" class="inputx" placeholder="Nombre" v-model="formCostCenter.name" />
          </div>
          <div style="align-self: flex-end; flex-basis: fit-content;" class="col-xl-6 col-md-6">
            <vs-checkbox style="font-size: medium;" v-model="formCostCenter.status">Estado</vs-checkbox>
          </div>
          <div style="align-self: flex-end; padding: 15px;" class="col-xl-4 col-md-4">
            <button style="border: none; background-color: #0d6efd; width: 100%;"
              class="btn btn-info btn-fill float-right" @click.prevent="createdEditCostCenter()">
              Insertar</button>
          </div>
        </div>
      </vs-popup>
      <vs-popup classContent="popup-example" title="Dependencia" :active.sync="popupCreatedDependence">
        <div class="row">
          <div class="col-xl-6 col-md-6">
            <vs-input label="Nombre" class="inputx" placeholder="Nombre" v-model="formDependence.name" />
          </div>
          <div style="align-self: flex-end; flex-basis: fit-content;" class="col-xl-6 col-md-6">
            <vs-checkbox style="font-size: medium;" v-model="formDependence.status">Estado</vs-checkbox>
          </div>
          <div style="align-self: flex-end; padding: 15px;" class="col-xl-4 col-md-4">
            <button style="border: none; background-color: #0d6efd; width: 100%;"
              class="btn btn-info btn-fill float-right" @click.prevent="createdEditDependence()">
              Insertar</button>
          </div>
        </div>
      </vs-popup>
      <vs-prompt @accept="deleteDriver" :active.sync="activePrompt" acceptText="Aceptar" cancelText="Cancelar"
        title="Eliminar">
        <div class="con-example-prompt">
          ¿Esta seguro que desea eliminar el conductor?
        </div>
      </vs-prompt>
      <vs-prompt @accept="deleteOperator" :active.sync="activePromptOperator" acceptText="Aceptar" cancelText="Cancelar"
        title="Eliminar">
        <div class="con-example-prompt">
          ¿Esta seguro que desea eliminar el Operador?
        </div>
      </vs-prompt>
      <vs-prompt @accept="deleteFee" :active.sync="activePromptFee" acceptText="Aceptar" cancelText="Cancelar"
        title="Eliminar">
        <div class="con-example-prompt">
          ¿Esta seguro que desea eliminar la Tarifa?
        </div>
      </vs-prompt>
      <vs-prompt @accept="deleteVehicle" :active.sync="activePromptVehicle" acceptText="Aceptar" cancelText="Cancelar"
        title="Eliminar">
        <div class="con-example-prompt">
          ¿Esta seguro que desea eliminar el Vehículo?
        </div>
      </vs-prompt>
      <vs-prompt @accept="deleteCosteCenter" :active.sync="activePromptCostCenter" acceptText="Aceptar"
        cancelText="Cancelar" title="Eliminar">
        <div class="con-example-prompt">
          ¿Esta seguro que desea eliminar el Centro de Costo?
        </div>
      </vs-prompt>
      <vs-prompt @accept="deleteDependence" :active.sync="activePromptDependence" acceptText="Aceptar"
        cancelText="Cancelar" title="Eliminar">
        <div class="con-example-prompt">
          ¿Esta seguro que desea eliminar la Dependence?
        </div>
      </vs-prompt>
    </div>
  </div>
</template>
<script>
import LTable from 'src/components/Table.vue'
import LTableFee from 'src/components/TableFee.vue'
import Card from 'src/components/Cards/Card.vue'
import Vue from 'vue'
import vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css'
import getSecret from '../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');
Vue.use(vuesax)
const tableColumns = ['Id', 'Nombre', 'Apellido', 'Documento', 'Dirección', 'Correo']
const tableColumns1 = ['Id', 'Nombre', 'Origen', 'Destino', 'Valor', 'Estado']
const tableColumns2 = ['Id', 'Nombre', 'Estado']
const tableColumns3 = ['Id', 'Cuenta', 'Placa', 'Marca', 'Modelo', 'Color', 'Estado']
export default {
  components: {
    LTable,
    LTableFee,
    Card
  },
  data() {
    return {
      id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      popupCreatedDriver: false,
      popupCreatedOperator: false,
      popupCreatedFee: false,
      popupCreatedVehicle: false,
      popupCreatedCostCenter: false,
      popupCreatedDependence: false,
      activePrompt: false,
      activePromptOperator: false,
      activePromptFee: false,
      activePromptVehicle: false,
      activePromptCostCenter: false,
      activePromptDependence: false,
      formDriver: {
        id_driver: null,
        name: '',
        lastName: '',
        phone: '',
        numberDocument: '',
        address: '',
        email: '',
        years: '',
        observations: '',
        status: true,
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company
      },
      formOperator: {
        id_operator: null,
        name: '',
        lastName: '',
        phone: '',
        numberDocument: '',
        address: '',
        email: '',
        years: '',
        observations: '',
        status: true,
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company
      },
      formFee: {
        id_fee: null,
        name: '',
        destination: '',
        origin: '',
        value: '',
        status: true,
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company
      },
      formVehicle: {
        id_vehicle: null,
        placa: '',
        marca: '',
        modelo: '',
        color: '',
        cuenta: '',
        status: true,
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company
      },
      formCostCenter: {
        id_cost_center: null,
        name: '',
        status: true,
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company
      },
      formDependence: {
        id_dependence: null,
        name: '',
        status: true,
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company
      },
      tableDriver: {
        columns: [...tableColumns],
        data: []
      },
      tableOperator: {
        columns: [...tableColumns],
        data: []
      },
      tableFee: {
        columns: [...tableColumns1],
        data: []
      },
      tableCostCenter: {
        columns: [...tableColumns2],
        data: []
      },
      tableDependence: {
        columns: [...tableColumns2],
        data: []
      },
      tableVehicle: {
        columns: [...tableColumns3],
        data: []
      },
    }
  },
  computed: {
    validatorForm() {
      if (this.formDriver.name == '' || this.formDriver.name == undefined || this.formDriver.name == null) return false;
      if (this.formDriver.lastName == '' || this.formDriver.lastName == undefined || this.formDriver.lastName == null) return false;
      if (this.formDriver.phone == '' || this.formDriver.phone == undefined || this.formDriver.phone == null) return false;
      if (this.formDriver.numberDocument == '' || this.formDriver.numberDocument == undefined || this.formDriver.numberDocument == null) return false;
      if (this.formDriver.address == '' || this.formDriver.address == undefined || this.formDriver.address == null) return false;
      if (this.formDriver.email == '' || this.formDriver.email == undefined || this.formDriver.email == null) return false;
      if (this.formDriver.years == '' || this.formDriver.years == undefined || this.formDriver.years == null) return false;
      if (this.formDriver.observations == '' || this.formDriver.observations == undefined || this.formDriver.observations == null) return false;
      return true;
    },
    validatorFormOperator() {
      if (this.formOperator.name == '' || this.formOperator.name == undefined || this.formOperator.name == null) return false;
      if (this.formOperator.lastName == '' || this.formOperator.lastName == undefined || this.formOperator.lastName == null) return false;
      if (this.formOperator.phone == '' || this.formOperator.phone == undefined || this.formOperator.phone == null) return false;
      if (this.formOperator.numberDocument == '' || this.formOperator.numberDocument == undefined || this.formOperator.numberDocument == null) return false;
      if (this.formOperator.address == '' || this.formOperator.address == undefined || this.formOperator.address == null) return false;
      if (this.formOperator.email == '' || this.formOperator.email == undefined || this.formOperator.email == null) return false;
      if (this.formOperator.years == '' || this.formOperator.years == undefined || this.formOperator.years == null) return false;
      if (this.formOperator.observations == '' || this.formOperator.observations == undefined || this.formOperator.observations == null) return false;
      return true;
    },
    validatorFormFee() {
      if (this.formFee.name == '' || this.formFee.name == undefined || this.formFee.name == null) return false;
      if (this.formFee.destination == '' || this.formFee.destination == undefined || this.formFee.destination == null) return false;
      if (this.formFee.origin == '' || this.formFee.origin == undefined || this.formFee.origin == null) return false;
      if (this.formFee.value == '' || this.formFee.value == undefined || this.formFee.value == null) return false;
      return true;
    },
    validatorFormVehicle() {
      if (this.formVehicle.placa == '' || this.formVehicle.placa == undefined || this.formVehicle.placa == null) return false;
      if (this.formVehicle.marca == '' || this.formVehicle.marca == undefined || this.formVehicle.marca == null) return false;
      if (this.formVehicle.modelo == '' || this.formVehicle.modelo == undefined || this.formVehicle.modelo == null) return false;
      if (this.formVehicle.color == '' || this.formVehicle.color == undefined || this.formVehicle.color == null) return false;
      if (this.formVehicle.cuenta == '' || this.formVehicle.cuenta == undefined || this.formVehicle.cuenta == null) return false;
      return true;
    },
    validatorFormCostCenter() {
      if (this.formCostCenter.name == '' || this.formCostCenter.name == undefined || this.formCostCenter.name == null) return false;
      return true;
    },
    validatorFormDependence() {
      if (this.formDependence.name == '' || this.formDependence.name == undefined || this.formDependence.name == null) return false;
      return true;
    },
  },
  methods: {
    confirmDeleteDriver(item) {
      this.activePrompt = true;
      this.id_item = item.id;
    },
    confirmDeleteOperator(item) {
      this.activePromptOperator = true;
      this.id_item = item.id;
    },
    confirmDeleteFee(item) {
      this.activePromptFee = true;
      this.id_item = item.id;
    },
    confirmDeleteVehicle(item) {
      this.activePromptVehicle = true;
      this.id_item = item.id;
    },
    confirmDeleteCostCenter(item) {
      this.activePromptCostCenter = true;
      this.id_item = item.id;
    },
    confirmDeleteDependence(item) {
      this.activePromptDependence = true;
      this.id_item = item.id;
    },
    editDriver(item) {
      this.formDriver.id_driver = item.id_driver;
      this.formDriver.name = item.name;
      this.formDriver.lastName = item.last_name;
      this.formDriver.phone = item.phone;
      this.formDriver.numberDocument = item.document_number;
      this.formDriver.address = item.address;
      this.formDriver.email = item.email;
      this.formDriver.years = item.years;
      this.formDriver.observations = item.observations;
      this.formDriver.status = item.status;
      this.popupCreatedDriver = true;
    },
    editOperator(item) {
      this.formOperator.id_operator = item.id_operator;
      this.formOperator.name = item.name;
      this.formOperator.lastName = item.last_name;
      this.formOperator.phone = item.phone;
      this.formOperator.numberDocument = item.document_number;
      this.formOperator.address = item.address;
      this.formOperator.email = item.email;
      this.formOperator.years = item.years;
      this.formOperator.observations = item.observations;
      this.formOperator.status = item.status;
      this.popupCreatedOperator = true;
    },
    editFee(item) {
      this.formFee.id_fee = item.id_fee;
      this.formFee.name = item.name;
      this.formFee.destination = item.destination;
      this.formFee.origin = item.origin;
      this.formFee.value = item.value;
      this.formFee.status = item.status;
      this.popupCreatedFee = true;
    },
    editVehicle(item) {
      this.formVehicle.id_vehicle = item.id_vehicle;
      this.formVehicle.placa = item.placa;
      this.formVehicle.marca = item.marca;
      this.formVehicle.modelo = item.modelo;
      this.formVehicle.color = item.color;
      this.formVehicle.cuenta = item.cuenta;
      this.formVehicle.status = item.status;
      this.popupCreatedVehicle = true;
    },
    editCostCenter(item) {
      this.formCostCenter.id_cost_center = item.id_cost_center;
      this.formCostCenter.name = item.name;
      this.formCostCenter.status = item.status;
      this.popupCreatedCostCenter = true;
    },
    editDependence(item) {
      this.formDependence.id_dependence = item.id_dependence;
      this.formDependence.name = item.name;
      this.formDependence.status = item.status;
      this.popupCreatedDependence = true;
    },
    deleteDriver() {
      this.axios.get(serverUrl + '/api/deleteDriver/' + this.id_item)
        .then(res => {
          if (res.data.status == 200) {
            this.getListDrivers();
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Conductor Eliminado con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'info'
            })
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar el conductor.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
          }
        })
        .catch(err => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar el conductor.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'bottom',
            verticalAlign: 'right',
            type: 'danger'
          })
        });
    },
    deleteOperator() {
      this.axios.get(serverUrl + '/api/deleteOperator/' + this.id_item)
        .then(res => {
          if (res.data.status == 200) {
            this.getListOperators();
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Operador Eliminado con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'info'
            })
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar el Operador.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
          }
        })
        .catch(err => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar el Operador.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'bottom',
            verticalAlign: 'right',
            type: 'danger'
          })
        });
    },
    deleteFee() {
      this.axios.get(serverUrl + '/api/deleteFee/' + this.id_item)
        .then(res => {
          if (res.data.status == 200) {
            this.getListFee();
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Tarifa Eliminada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'info'
            })
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar la Tarifa.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
          }
        })
        .catch(err => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar la Tarifa.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'bottom',
            verticalAlign: 'right',
            type: 'danger'
          })
        });
    },
    deleteVehicle() {
      this.axios.get(serverUrl + '/api/deleteVehicle/' + this.id_item)
        .then(res => {
          if (res.data.status == 200) {
            this.getListVehicle();
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Vehículo Eliminado con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'info'
            })
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar el Vehículo.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
          }
        })
        .catch(err => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar el Vehículo.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'bottom',
            verticalAlign: 'right',
            type: 'danger'
          })
        });
    },
    deleteCosteCenter() {
      this.axios.get(serverUrl + '/api/deleteCostCenter/' + this.id_item)
        .then(res => {
          if (res.data.status == 200) {
            this.getListCostCenter();
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Centro de Costo Eliminado con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'info'
            })
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar el Centro de Costo.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
          }
        })
        .catch(err => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar el Centro de Costo.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'bottom',
            verticalAlign: 'right',
            type: 'danger'
          })
        });
    },
    deleteDependence() {
      this.axios.get(serverUrl + '/api/deleteDependence/' + this.id_item)
        .then(res => {
          if (res.data.status == 200) {
            this.getListDependence();
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Dependencia Eliminada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'info'
            })
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar la Dependencia.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
          }
        })
        .catch(err => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar la Dependencia.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'bottom',
            verticalAlign: 'right',
            type: 'danger'
          })
        });
    },
    getListDrivers() {
      this.axios.get(serverUrl + '/api/getListDrivers/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            this.tableDriver.data = res.data.drivers;
          } else {
            console.log('Error getListDrivers');
          }
        })
        .catch(err => {
          console.log('Error getListDrivers');
        });
    },
    getListOperators() {
      this.axios.get(serverUrl + '/api/getListOperators/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            this.tableOperator.data = res.data.operators;
          } else {
            console.log('Error getListOperator');
          }
        })
        .catch(err => {
          console.log('Error getListOperator');
        });
    },
    getListFee() {
      this.axios.get(serverUrl + '/api/getListFee/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            this.tableFee.data = res.data.fees;
          } else {
            console.log('Error getListFee');
          }
        })
        .catch(err => {
          console.log('Error getListFee');
        });
    },
    getListVehicle() {
      this.axios.get(serverUrl + '/api/getListVehicle/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            this.tableVehicle.data = res.data.vehicles;
          } else {
            console.log('Error getListVehicle');
          }
        })
        .catch(err => {
          console.log('Error getListVehicle');
        });
    },
    getListCostCenter() {
      this.axios.get(serverUrl + '/api/getListCostCenter/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            this.tableCostCenter.data = res.data.costCenters;
          } else {
            console.log('Error getListCostCenter');
          }
        })
        .catch(err => {
          console.log('Error getListCostCenter');
        });
    },
    getListDependence() {
      this.axios.get(serverUrl + '/api/getListDependence/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            this.tableDependence.data = res.data.dependences;
          } else {
            console.log('Error getListDependence');
          }
        })
        .catch(err => {
          console.log('Error getListDependence');
        });
    },
    createdEditDriver() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      if (this.validatorForm) {
        this.axios.post(serverUrl + '/api/createdEditDriver', this.formDriver)
          .then(res => {
            this.popupCreatedDriver = false;
            if (res.data.status == 200) {
              this.$notifications.notify({
                message: `<span><b>¡Éxito!</b><br>Conductor Creado o Actualizado con Éxito.</span>`,
                icon: 'nc-icon nc-send',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'info'
              })
              this.formDriver.id_driver = null;
              this.formDriver.name = '';
              this.formDriver.lastName = '';
              this.formDriver.phone = '';
              this.formDriver.numberDocument = '';
              this.formDriver.address = '';
              this.formDriver.email = '';
              this.formDriver.years = '';
              this.formDriver.observations = '';
              this.formDriver.status = true;
              this.getListDrivers();
              this.$vs.loading.close();
            } else {
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar el conductor.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'danger'
              })
              this.$vs.loading.close();
            }
          })
          .catch(err => {
            this.popupCreatedDriver = false;
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar el conductor.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
            this.$vs.loading.close();
          });
      } else {
        setTimeout(this.closeLoading, 500);
        this.popupCreatedDriver = false;
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>No se pudo Crear el Conductor, debe completar todos los campos.</span>`,
          icon: 'nc-icon nc-support-17',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger'
        })
      }
    },
    createdEditOperator() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      if (this.validatorFormOperator) {
        this.axios.post(serverUrl + '/api/createdEditOperator', this.formOperator)
          .then(res => {
            this.popupCreatedOperator = false;
            if (res.data.status == 200) {
              this.$notifications.notify({
                message: `<span><b>¡Éxito!</b><br>Operador Creado o Actualizado con Éxito.</span>`,
                icon: 'nc-icon nc-send',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'info'
              })
              this.formOperator.id_operator = null;
              this.formOperator.name = '';
              this.formOperator.lastName = '';
              this.formOperator.phone = '';
              this.formOperator.numberDocument = '';
              this.formOperator.address = '';
              this.formOperator.email = '';
              this.formOperator.years = '';
              this.formOperator.observations = '';
              this.formOperator.status = true;
              this.getListOperators();
              this.$vs.loading.close();
            } else {
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar el Operador.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'danger'
              })
              this.$vs.loading.close();
            }
          })
          .catch(err => {
            this.popupCreatedOperator = false;
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar el Operador.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
            this.$vs.loading.close();
          });
      } else {
        setTimeout(this.closeLoading, 500);
        this.popupCreatedOperator = false;
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>No se pudo Crear el Operador, debe completar todos los campos.</span>`,
          icon: 'nc-icon nc-support-17',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger'
        })
      }
    },
    createdEditFee() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      if (this.validatorFormFee) {
        this.axios.post(serverUrl + '/api/createdEditFee', this.formFee)
          .then(res => {
            this.popupCreatedFee = false;
            if (res.data.status == 200) {
              this.$notifications.notify({
                message: `<span><b>¡Éxito!</b><br>Tarifa Creado o Actualizado con Éxito.</span>`,
                icon: 'nc-icon nc-send',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'info'
              })
              this.formFee.id_fee = null;
              this.formFee.name = '';
              this.formFee.destination = '';
              this.formFee.origin = '';
              this.formFee.value = '';
              this.formFee.status = true;
              this.getListFee();
              this.$vs.loading.close();
            } else {
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar la Tarifa.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'danger'
              })
              this.$vs.loading.close();
            }
          })
          .catch(err => {
            this.popupCreatedFee = false;
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar la Tarifa.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
            this.$vs.loading.close();
          });
      } else {
        setTimeout(this.closeLoading, 500);
        this.popupCreatedFee = false;
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>No se pudo Crear el Servicio, debe completar todos los campos.</span>`,
          icon: 'nc-icon nc-support-17',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger'
        })
      }
    },
    createdEditVehicle() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      if (this.validatorFormVehicle) {
        this.axios.post(serverUrl + '/api/createdEditVehicle', this.formVehicle)
          .then(res => {
            this.popupCreatedVehicle = false;
            if (res.data.status == 200) {
              this.$notifications.notify({
                message: `<span><b>¡Éxito!</b><br>Vehículo Creado o Actualizado con Éxito.</span>`,
                icon: 'nc-icon nc-send',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'info'
              })
              this.formVehicle.id_vehicle = null;
              this.formVehicle.marca = '';
              this.formVehicle.modelo = '';
              this.formVehicle.placa = '';
              this.formVehicle.color = '';
              this.formVehicle.cuenta = '';
              this.formVehicle.status = true;
              this.getListVehicle();
              this.$vs.loading.close();
            } else {
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar el Vehículo.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'danger'
              })
              this.$vs.loading.close();
            }
          })
          .catch(err => {
            this.popupCreatedVehicle = false;
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar el Vehículo.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
            this.$vs.loading.close();
          });
      } else {
        setTimeout(this.closeLoading, 500);
        this.popupCreatedVehicle = false;
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>No se pudo Crear el Vehiculo, debe completar todos los campos.</span>`,
          icon: 'nc-icon nc-support-17',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger'
        })
      }
    },
    createdEditCostCenter() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      if (this.validatorFormCostCenter) {
        this.axios.post(serverUrl + '/api/createdEditCostCenter', this.formCostCenter)
          .then(res => {
            this.popupCreatedCostCenter = false;
            if (res.data.status == 200) {
              this.$notifications.notify({
                message: `<span><b>¡Éxito!</b><br>Centro de costo Creado o Actualizado con Éxito.</span>`,
                icon: 'nc-icon nc-send',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'info'
              })
              this.formCostCenter.id_cost_center = null;
              this.formCostCenter.name = '';
              this.formCostCenter.status = true;
              this.getListCostCenter();
              this.$vs.loading.close();
            } else {
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar el Centro de costo.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'danger'
              })
              this.$vs.loading.close();
            }
          })
          .catch(err => {
            this.popupCreatedCostCenter = false;
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar el Centro de costo.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
            this.$vs.loading.close();
          });
      } else {
        setTimeout(this.closeLoading, 500);
        this.popupCreatedCostCenter = false;
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>No se pudo Crear el Centro de Costo, debe completar todos los campos.</span>`,
          icon: 'nc-icon nc-support-17',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger'
        })
      }
    },
    createdEditDependence() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      if (this.validatorFormDependence) {
        this.axios.post(serverUrl + '/api/createdEditDependence', this.formDependence)
          .then(res => {
            this.popupCreatedDependence = false;
            if (res.data.status == 200) {
              this.$notifications.notify({
                message: `<span><b>¡Éxito!</b><br>Dependencia Creada o Actualizada con Éxito.</span>`,
                icon: 'nc-icon nc-send',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'info'
              })
              this.formDependence.id_dependence = null;
              this.formDependence.name = '';
              this.formDependence.status = true;
              this.getListDependence();
              this.$vs.loading.close();
            } else {
              this.$notifications.notify({
                message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar la Dependencia.</span>`,
                icon: 'nc-icon nc-support-17',
                horizontalAlign: 'bottom',
                verticalAlign: 'right',
                type: 'danger'
              })
              this.$vs.loading.close();
            }
          })
          .catch(err => {
            this.popupCreatedDependence = false;
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al crear o editar la Dependencia.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'bottom',
              verticalAlign: 'right',
              type: 'danger'
            })
            this.$vs.loading.close();
          });
      } else {
        setTimeout(this.closeLoading, 500);
        this.popupCreatedDependence = false;
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>No se pudo Crear la Dependencia, debe completar todos los campos.</span>`,
          icon: 'nc-icon nc-support-17',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'danger'
        })
      }
    },
    openCreateDriverPopup() {
      this.formDriver.id_driver = null;
      this.formDriver.name = '';
      this.formDriver.lastName = '';
      this.formDriver.phone = '';
      this.formDriver.numberDocument = '';
      this.formDriver.address = '';
      this.formDriver.email = '';
      this.formDriver.years = '';
      this.formDriver.observations = '';
      this.formDriver.status = true;
      this.popupCreatedDriver = true;
    },
    openCreateOperatorPopup() {
      this.formOperator.id_operator = null;
      this.formOperator.name = '';
      this.formOperator.lastName = '';
      this.formOperator.phone = '';
      this.formOperator.numberDocument = '';
      this.formOperator.address = '';
      this.formOperator.email = '';
      this.formOperator.years = '';
      this.formOperator.observations = '';
      this.formOperator.status = true;
      this.popupCreatedOperator = true;
    },
    openCreateFeePopup() {
      this.formFee.id_fee = null;
      this.formFee.name = '';
      this.formFee.destination = '';
      this.formFee.origin = '';
      this.formFee.value = '';
      this.formFee.status = true;
      this.popupCreatedFee = true;
    },
    openCreateVehiclePopup() {
      this.formVehicle.id_vehicle = null;
      this.formVehicle.marca = '';
      this.formVehicle.modelo = '';
      this.formVehicle.placa = '';
      this.formVehicle.color = '';
      this.formVehicle.cuenta = '';
      this.formVehicle.status = true;
      this.popupCreatedVehicle = true;
    },
    openCreateCostCenterPopup() {
      this.formCostCenter.id_cost_center = null;
      this.formCostCenter.name = '';
      this.formCostCenter.status = true;
      this.popupCreatedCostCenter = true;
    },
    openCreateDependencePopup() {
      this.formDependence.id_dependence = null;
      this.formDependence.name = '';
      this.formDependence.status = true;
      this.popupCreatedDependence = true;
    },
    closeLoading() {
      this.$vs.loading.close();
    },
  },
  created() {
  },
  mounted() {
    this.getListDrivers();
    //this.getListOperators();
    this.getListFee();
    this.getListVehicle();
    //this.getListCostCenter();
    this.getListDependence();
  }
}
</script>
<style>
input {
  height: auto !important;
}

.card label {
  text-transform: none !important;
  ;
}

.vs-icon {
  font-size: medium;
}

.con-example-prompt {
  padding: 10px;
  padding-bottom: 0px;
}

.con-example-prompt .vs-input {
  width: 100%;
  margin-top: 10px;
}

.vs-button {
  width: auto !important;
  margin: 0 !important;
  height: auto !important;
  font-size: 1rem !important;
}
</style>
